import { render, staticRenderFns } from "./ImportadorListaNominal.vue?vue&type=template&id=117f11aa&scoped=true"
import script from "./ImportadorListaNominal.vue?vue&type=script&lang=js"
export * from "./ImportadorListaNominal.vue?vue&type=script&lang=js"
import style0 from "./ImportadorListaNominal.vue?vue&type=style&index=0&id=117f11aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f11aa",
  null
  
)

export default component.exports